/**
 * /quotes
 *
 * Public page listing all active quotes. Simple, browsable,
 * warm-feeling. Each quote is a card with the body and attribution.
 */

import { useEffect, useState } from 'react';

import { listQuotes } from '../api/quotes.js';
import SiteHeader from '../components/SiteHeader.jsx';
import { usePageTitle } from '../hooks/usePageTitle.js';
import './QuotesPage.css';


export default function QuotesPage() {
  usePageTitle('Quotes');

  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    listQuotes()
      .then((data) => { if (!cancelled) setQuotes(data); })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="quotes-page">
      <SiteHeader adminHref="/admin/quotes" />

      <div className="quotes-container">
      <div className="quotes-header">
        <img
          src="/nacho-007.png"
          alt="Thinking Nacho"
          className="quotes-nacho"
        />
        <h1 className="quotes-title">Quotes</h1>
        <p className="quotes-sub">
          things people said, or maybe didn't — we're not fact-checking this
        </p>
      </div>

        {loading ? (
          <div className="quotes-muted">loading…</div>
        ) : quotes.length === 0 ? (
          <div className="quotes-muted">
            no quotes yet. the silence is deafening.
          </div>
        ) : (
          <div className="quotes-list">
            {quotes.map((q) => (
              <blockquote key={q.id} className="quote-card">
                <p className="quote-body">{q.body}</p>
                {q.attribution ? (
                  <footer className="quote-attribution">— {q.attribution}</footer>
                ) : (
                  <footer className="quote-attribution quote-attribution--anon">
                    — heard somewhere
                  </footer>
                )}
              </blockquote>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
